import Popup from "../UI/Popup";

class FullScreenRequest {
    public element: HTMLElement;
    private resolve: (eventData: IFullscreenGrantedRestoredEventData) => void;
    private reject: (eventData: IFullscreenErroredEventData) => void;
    private options: IRequestFullScreenOptions;


    public constructor(element: HTMLElement, resolve: (eventData: IFullscreenGrantedRestoredEventData) => void, reject: (eventData: IFullscreenErroredEventData) => void, options: IRequestFullScreenOptions) {
        this.element = element;
        this.resolve = resolve;
        this.reject = reject;
        this.options = options;
    }

    public fullscreen(): void {
        var eventData = { element: this.element };

        /* Add an popup wrapper to element */
        $("#fullscreen-element-popup-wrapper").remove(); // remove existing wrapper in case it lingered
        $(this.element).append('<div id="fullscreen-element-popup-wrapper" style="width: 0; height:0;" />');

        try {
            /* Event */
            if (this.options && this.options.fullscreen) {
                this.options.fullscreen(eventData);
            }
        } catch (e) {
            console.error(e);
        }       

        /* Resolve promise */
        this.resolve(eventData);
    }
    public restore(): void {
        /* Remove popup wrapper from element */
        const $fullscreenPopupWrapper = $("#fullscreen-element-popup-wrapper");
        if ($fullscreenPopupWrapper.length) {
            /* Kendo cant handle moving DOM elements around so close the popup instead of moving it to document level */
            const awfPopup = $fullscreenPopupWrapper.find('#CMSPopup').data('awfPopup') as Popup;
            if (awfPopup != null) {
                awfPopup.close();
            }           
        }        

        $fullscreenPopupWrapper.remove(); // remove existing wrapper in case it lingered        

        var eventData = { element: this.element };
        if (this.options && this.options.restore) {
            this.options.restore(eventData);
        }
    }
    public error(errorMessage: string): void {
        var eventData = { errorMessage: errorMessage };
        if (this.options && this.options.error) {
            this.options.error(eventData);
        }
        this.reject(eventData);
    }
}


export interface IFullscreenGrantedRestoredEventData {
    element: HTMLElement;
}
export interface IFullscreenErroredEventData {
    errorMessage: string;
}
export interface IRequestFullScreenOptions {
    fullscreen?: (eventData: IFullscreenGrantedRestoredEventData) => void;
    restore?: (eventData: IFullscreenGrantedRestoredEventData) => void;
    error?: (eventData: IFullscreenErroredEventData) => void;
}

var fullscreenHandlersAdded = false;
var pendingRequests: Array<FullScreenRequest> = [];
var currentFullscreen: FullScreenRequest;


function getFullScreenChangeEventName() {
    if ((<any>document)["exitFullscreen"]) {
        return "fullscreenchange";
    } else if ((<any>document)["webkitCancelFullScreen"]) {
        return "webkitfullscreenchange";
    }
    else if ((<any>document)["msExitFullscreen"]) {
        return "MSFullscreenChange";
    }
    else if ((<any>document)["mozCancelFullScreen"]) {
        return "mozfullscreenchange";
    }

    // FullScreen API doesnt seem to be supported return W3C event name anyway
    return "fullscreenchange";
}

function getFullScreenErrorEventName() {
    if ((<any>document)["exitFullscreen"]) {
        return "fullscreenerror";
    } else if ((<any>document)["webkitCancelFullScreen"]) {
        return "webkitfullscreenerror";
    }
    else if ((<any>document)["msExitFullscreen"]) {
        return "MSFullscreenError";
    }
    else if ((<any>document)["mozCancelFullScreen"]) {
        return "mozfullscreenerror";
    }

    // FullScreen API doesnt seem to be supported return W3C event name anyway
    return "fullscreenerror";
}


function getFullScreenElement() {
    var doc = <any>document;
    return (doc["fullscreenElement"]) || (doc["webkitFullscreenElement"]) || (doc["webkitCurrentFullScreenElement"]) || (doc["msFullscreenElement"]) || (doc["mozFullScreenElement"]);
}
function isFullScreen() {
    var doc = <any>document;
    return !!doc["fullscreenElement"] || !!doc["msFullscreenElement"] || !!doc["webkitIsFullScreen"] || !!doc["mozFullScreen"];
}


function registerFullScreenHandlers() {
    var changeEvent = getFullScreenChangeEventName();
    var errorEvent = getFullScreenErrorEventName();

    document.addEventListener(changeEvent, (event) => {
        var isFullScreenEvent = isFullScreen();
        if (isFullScreenEvent) {
            /* Element became full screen */
            var fullScreenElement = getFullScreenElement();

            var pendingRequest = pendingRequests.shift();
            while (pendingRequest != null) {
                if (pendingRequest.element == fullScreenElement) {
                    pendingRequest.fullscreen();
                    currentFullscreen = pendingRequest; /* store current full screen*/
                } else {
                    pendingRequest.error('Different element');
                }
                pendingRequest = pendingRequests.shift();
            }
        } else {
            /* Element restored from full screen */
            if (currentFullscreen) {
                currentFullscreen.restore();
            }
            currentFullscreen = null;
        }
    });
    document.addEventListener(errorEvent, (event) => {
        /* Reject all pending requests (Note: there should only be one pending request) */
        var pendingRequest = pendingRequests.shift();
        while (pendingRequest != null) {
            pendingRequest.error('Error');
            pendingRequest = pendingRequests.shift();
        }
    });

    fullscreenHandlersAdded = true;
}



export function requestFullscreen(element: HTMLElement, options?: IRequestFullScreenOptions) {
    if (!fullscreenHandlersAdded) {
        registerFullScreenHandlers();
    }

    return new Promise((resolve, reject) => {
        /* Determine browser specific fullscreen function */
        var el = <any>element;
        var requestFullscreenFunc = (el["requestFullscreen"]) || (el["webkitRequestFullscreen"]) || (el["webkitRequestFullScreen"]) || (el["msRequestFullscreen"]) || (el["mozRequestFullScreen"]);

        /* Call fullscreen function */
        if (requestFullscreenFunc) {
            var request = new FullScreenRequest(element, resolve, reject, options);
            pendingRequests.push(request);

            requestFullscreenFunc.call(el);
        }
    });
}

export function exitFullscreen() {
    /* Determine browser specific exit function */
    var doc = <any>document;
    var exitFunc = (doc["exitFullscreen"]) || (doc["webkitExitFullscreen"]) || (doc["webkitCancelFullScreen"]) || (doc["msExitFullscreen"]) || (doc["mozCancelFullScreen"]);

    /* Call exit function */
    if (exitFunc) { exitFunc.call(doc); }
    return this;
}
